import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" stroke="#000" strokeWidth="2" {...props}><path d="M0 10h20M10 0v20" /></svg>;